import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { CKEditor } from 'ckeditor4-react';
import BigNumber from 'bignumber.js'
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import * as myConstList from '../../../BaseUrl';
const baseUrl = myConstList.baseUrl;
class PairSection extends React.Component {

    constructor(props) {
        super(props);
        const { user } = this.props.auth;
        this.state = {
            records: [],
            id: this.props.match.params.id,
            pairRecord: [],
            pairSerachRecord:'',
            errors: {},
            virtualFundassign: 0,
            pair_idArr: this.props.pairs,
            baseUrl:this.props.urldummy,
            tempArrPair:[],
            pair:[],
            pairSectionFlag:'1',
            urltemp:"?source="+localStorage.getItem("source")+"&theme="+localStorage.getItem("theme"),
        };
        var classThis = this;
    }

    componentWillReceiveProps(nextProps) {
		
        if (nextProps.pairs) {
			this.setState({ pair_idArr: nextProps.pairs })
        }
        if(this.state.pairSectionFlag==1){
			// console.log("this.state.pair_idArr==",this.state.pair_idArr);
            var classThis = this;
            var newpair = [];
            this.state.pair_idArr.map(function (value, i) {
				// console.log("this.state.pair_idArr==",value);
                if(value.name !== null){
                    // fetch(`${baseUrl}api/ticker-data?symbol=${value.name}USDT`)
                    // .then(response => response.json())
                    // .then(response => {
                        // console.log("par-response==",response.data.lastPrice);
                        // var pricess = parseFloat(response.data.lastPrice);
                        // pricess = pricess<0.0001 && pricess>0.000001?parseFloat(pricess).toFixed(8):pricess<0.1 && pricess>0.0001?parseFloat(pricess).toFixed(6):pricess<1 && pricess>0.1?parseFloat(pricess).toFixed(4):pricess>1?parseFloat(pricess).toFixed(2):parseFloat(pricess).toFixed(2);

                        var objPair={symbol:value.name+"USDT",priceChangePercent:0,lastPrice:0};
                        newpair.push(objPair);
                            classThis.setState({ pairRecord: newpair,pairSectionFlag:'2' })
                    // })
                    // .catch();
                }
            })
        }
    }
    
showChatHtml = () => {
        const url = window.location.href;
        var lastSegment1 = url.split("/").pop();
        var lastSegment2 = lastSegment1.split("?");
        var lastSegment = lastSegment2[0];
        var searcString = this.state.pairSerachRecord;
        const html = []
        var classThis=this;
        var filterRecord = this.state.pairRecord;
     
        if(searcString ==""){
            var newArray = filterRecord;
        }else{
            var newArray = filterRecord.filter(function (el) {
                return  el.symbol.search(searcString.toUpperCase()) != -1;
              });
        }
        
        newArray.map(function (value, i) {
            let urlSymbol = value.symbol.slice(0, -4)+"-"+value.symbol.slice(-4);
            html.push(
                <>
                    <tr key={i}>
                        <td className="align-middle" value={value.symbol} >
                            <a href={"/exchange/" + classThis.props.match.params.id+"/"+classThis.props.match.params.exchangetype + "/" + urlSymbol+classThis.state.urltemp} style={{ color: lastSegment.replace("-","")==value.symbol ? '#dbb747' : ''}}>
                                <i className="las la-star stsr5 mr-1"></i>{value.symbol.slice(0, -4)}/{value.symbol.slice(-4)}</a>
                        </td>
                            {/* <td><span className="pr-2"> <strong className="ng-binding"><span className={value.priceChangePercent < 0 ? 'text-danger' : 'text-success'}>{value.lastPrice}</span></strong></span></td>
                        <td className="tr"><b className="crypt-down"><span className={value.priceChangePercent < 0 ? 'text-danger' : 'text-success'}>{value.priceChangePercent+"%"}</span></b> </td> */}
                        </tr>
                   {/* <tr>
                        <td className="align-middle" value={value.symbol} >
                        <a href={"/exchange/"+classThis.state.id+"/"+value.symbol} style={{ color: lastSegment==value.symbol ? '#dbb747' : '#f2f4f5' }}><i className="las la-star stsr5"></i>{value.symbol}</a></td>
                        <td><span className="pr-2">{value.lastPrice}</span></td>
                        <td className="tr"><b className="crypt-down">{value.priceChangePercent}</b> </td>
                    </tr> */}
                </>
            );
        })
        return html;
    }
    searchPair = e => {
        const strongRegexName = new RegExp(/^[a-zA-Z]*$/);
        var testPair = strongRegexName.test(e.target.value);
        if (testPair){
            this.state.pairSerachRecord=e.target.value;
            this.showChatHtml();  
        }
    };

    render() {
        return (
            <div className="crypt-market-status mt-3 pair-mobile-none">
                <div> 
                    <div className="tab-content crypt-tab-content">
                        <div role="tabpanel" className="tab-pane active show" id="btc">
                            <div className="searchFilter f-cb">
                                <div className="search-box search-box-new">
                                <input type="text" id="search-int" placeholder="" className="ng-pristine ng-untouched ng-valid ng-empty" onChange={this.searchPair}/>                           
                                    <i className="las la-search"></i>
                                </div>                              
                                <div className="cls"></div>
                            </div>
                            <table className="table border_none mb-0">
                                <thead>
                                    <tr>
                                        <th className="col-4">Pair</th>
                                        {/* <th className="col-4">Price</th> */}
                                        {/* <th className="col-4 tr">Change</th> */}
                                    </tr>
                                </thead>
                            </table>
                            <div className="table-overflow mb-2">

                                <table className="table border_none  mb-0">

                                    <tbody className="crypt-table-hover">

                                        {this.showChatHtml()}


                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

PairSection.propTypes = {

    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});
export default connect(

    state => state
)(withRouter(PairSection));